<template>
  <div>
    <el-dialog
      title="异常处理"
      :visible.sync="showEdit"
      @close="remarkClose"
      width="60%"
      class="abnormal complaint remark_modal"
      :append-to-body="true"
      id="orderlist"
    >
      <div class="remark-add markup-t">
        <div class="increase_price_form">
          <el-form
            :model="params"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            class="demo-ruleForm"
          >
            <el-row :gutter="36">
              <el-col :span="24">
                <el-form-item label="处理状态" prop="status">
                  <el-radio-group v-model="params.status">
                    <el-radio
                      v-if="item.value != 'NOT_FOLLOW_UP'"
                      v-for="item in followOptions"
                      :label="item.value"
                      border
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="处理结果" prop="content">
                  <el-input
                    class="default-input default-input-remark"
                    v-model="params.content"
                    placeholder="请输入内容"
                    type="textarea"
                    :maxlength="500"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="处理图片"
                  class="complaint-img eva-upload-imgs genjinupload"
                >
                  <a-upload
                    accept="image/*"
                    :action="baseApl + '/common/common/upload_file'"
                    listType="picture-card"
                    :fileList="followUpList"
                    @change="followUpChange"
                    @preview="handlePreview"
                    :data="webToken"
                    :headers="webToken"
                  >
                    <div v-if="followUpList.length < 8">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">上传</div>
                    </div>
                  </a-upload>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="加价" class="markup_label">
                  <!-- <el-switch :disabled="remarkInfo.orderType=='TIMELY'" v-model="params.isMarkup" active-color="#3455D3"> </el-switch><span v-if="remarkInfo.orderType=='TIMELY'" class="jiajia">此异常为即时服务订单，如需加价处理请“联系平台”</span> -->
                  <el-switch
                    :disabled="remarkInfo.orderType == 'TIMELY'"
                    v-model="params.isMarkup"
                    active-color="#3455D3"
                    @change="checkSwitch"
                  >
                  </el-switch
                  ><span v-if="remarkInfo.orderType == 'TIMELY'" class="jiajia"
                    >此异常为即时服务订单，如需加价处理请“联系平台”</span
                  >
                </el-form-item>
              </el-col>
              <template v-if="markup">
                <el-col :span="8">
                  <el-form-item label="追加费用" prop="additionalFee">
                    <el-input
                      class="default-input"
                      v-model="params.additionalFee"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      @input="watchNumber"
                      placeholder="请输入追加费用"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </el-form>
          <template v-if="markup">
            <el-row class="pay_type">
              <div class="zf-tit">支付方式</div>
              <div class="pay_modes">
                <div
                  class="pay_mode"
                  :class="{ pay_selected: payMode[0].selected }"
                  @click="payMethod('WALLET')"
                >
                  <svg class="icon icona_xiadan_yue" aria-hidden="true">
                    <use xlink:href="#icona_xiadan_yue" />
                  </svg>
                  <div class="pay_mode_right">余额支付</div>
                </div>
              </div>
            </el-row>
            <div class="yue_money" v-if="payMode[0].selected">
              余额：¥{{ balance }}
            </div>
            <div
              class="recharge"
              v-if="payMode[0].selected && params.additionalFee - balance >= 0"
            >
              您的余额不足
              <span @click="goRecharge()" style="cursor: pointer">
                前往充值
                <i class="iconfont iconbiaodan_rili_right"></i>
              </span>
            </div>
          </template>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkClose">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm()"
          :loading="loading"
          :disabled="params.additionalFee - balance >= 0 && params.isMarkup"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
    <password-modal ref="passwordModal" @ok="submitForm"></password-modal>
  </div>
</template>

<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
import { getAction, postAction } from "@/api/manage";
import * as Constant from "@/utils/constant";
import { arithmeticMultiply, arithmeticDivide } from "@/utils/util";
import passwordModal from "./passwordModal";

export default {
  components: { passwordModal },
  data() {
    return {
      followOptions: Constant.FOLLOW_TYPE,
      params: {
        isMarkup:false
      },
      rules: {
        status: [
          { required: true, message: "请选择处理状态", trigger: "change" },
        ],
        content: [
          { required: true, message: "请输入处理内容", trigger: "change" },
        ],
        additionalFee: [
          { required: true, message: "请输入加价金额", trigger: "change" },
        ],
      },
      remark: "",
      showEdit: false,
      previewVisible: false,
      previewImage: "",
      followUpList: [],
      remarkInfo: {
        orderItems: [],
      },
      baseApl: process.env.VUE_APP_BASE_API,
      loading: false,
      webToken: {
        WEB_TOKEN: Cookies.get("token"),
      },
      followUpInfo: {},
      markup: false,
      balance: "",
      orderPayWay: [],
      payMode: [
        { selected: true, name: "WALLET" },
        { selected: false, name: "ALIPAY" },
        { selected: false, name: "WECHAT" },
      ],
    };
  },
  mounted() {
    var _this = this;
    if (Cookies.get("token") != undefined) {
      this.$fetch(`/user/api/customer/balance`).then((res) => {
        if (res.code == 0) {
          _this.balance = res.data.balance;
        } else {
          this.$message(res.message);
        }
      });
      // 获取可用支付方式
      this.$fetch(`/common/platform/get_pay_way`).then((res) => {
        if (res.code == 0) {
          this.orderPayWay = res.data.orderPayWay;
          // 设置默认支付方式
          this.payMethod(res.data.orderPayWay[0]);
        } else {
          this.$message(res.message);
        }
      });
    }
  },
  methods: {
    // 跳转充值
    goRecharge() {
      this.$router.push({ path: "/user/wallet/recharge" });
    },
    // 支付方式
    payMethod(item) {
      for (let i of this.payMode) {
        i.selected = false;
        if (item == i.name) {
          i.selected = true;
        }
      }
      this.payWayEnum = item;
    },
    // 保留两位小数
    watchNumber(e) {
      console.log(e);
      if (e.split(".").length == 3) {
        this.params.additionalFee = e.substr(0, e.length - 1);
      } else {
        if (e.split(".")[1]) {
          this.params.additionalFee = arithmeticDivide(
            Math.floor(arithmeticMultiply(e, 100)),
            100
          );
        }
      }
    },
    // 点击是否加价
    checkSwitch(e) {
      if (
        (e && this.remarkInfo.status == "SUCCESS") ||
        this.remarkInfo.status == "EVALUATED"
      ) {
        this.$confirm(
          "当前订单已交易成功，无法申请退款。订单加价支付后将会直接到师傅账上。",
          "加价提醒",
          {
            confirmButtonText: "我知道了",
            cancelButtonText: "不加价了",
            type: "warning",
          }
        )
          .then(() => {
            this.markup = true;
          })
          .catch(() => {
            this.params.isMarkup = false;
            this.markup = false;
          });
      } else {
        if (!e) {
          // delete this.params.isMarkup;
          delete this.params.additionalFee;
          this.markup = false;
        } else this.markup = true;
      }
    },
    add(item) {
      this.remarkInfo = item;
      this.showEdit = true;
      this.params = {
        isMarkup:false
      };
    },
    // 备注弹窗关闭
    remarkClose() {
      this.params = {
        isMarkup:false
      };
      this.markup = false;
      this.showEdit = false;
      this.followUpList = [];
      this.$refs.passwordModal.verificationCode = "";
      this.$refs["ruleForm"].resetFields();
    },
    // 订单跟进拍照
    followUpChange({ fileList }) {
      this.followUpList = fileList;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    submitForm(e) {
      this.$message.closeAll();
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.params.isMarkup && !e) {
            return (this.$refs.passwordModal.dialogVisible = true);
          }
          let imgList = this.followUpList.map(
            (i) => i.url || i.response.data.url
          );
          this.loading = true;
          let params = Object.assign(this.params, {
            image: imgList.join(","),
            orderAbnormalId: this.remarkInfo.id,
            isMarkup: this.params.isMarkup,
            walletPassword: e,
            additionalFee: this.params.additionalFee,
          });
          postAction("/order/api/abnormal/add_abnormal_record", params)
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                this.$message({
                  message: "处理成功",
                  type: "success",
                });
                this.$emit("ok");
                this.remarkClose();
              } else {
                this.$message(res.data.message);
              }
            })
            .finally(() => {
              this.remarkClose();
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.pay_type {
  display: flex;
  align-items: center;
  .zf-tit {
    margin-right: 0;
    margin-bottom: 0 !important;
    width: 80px;
    padding-right: 12px;
    text-align: right;
  }
}
.yue_money {
  font-size: 14px !important;
  height: 14px !important;
  margin-left: 80px;
}
.recharge {
  margin-left: 80px;
}
.pay_modes {
  .pay_mode {
    width: 190px !important;
    height: 100px !important;
    padding: 20px 0 20px 22px !important;
    .icon {
      width: 56px !important;
      height: 56px !important;
      margin-right: 3px !important;
    }
    .pay_mode_right {
      height: 56px !important;
    }
  }
}
.markup_label {
  /deep/.el-form-item__content {
    margin-left: 80px;
    display: flex;
    align-items: center;
  }
}
.jiajia {
  color: #ffad16;
  font-size: 14px;
  margin-left: 8px;
}
/deep/.el-form-item {
  margin-bottom: 16px;
}
/deep/.default-input {
  width: 100%;
  textarea {
    height: 80px;
  }
  .el-input__suffix {
    width: auto;
  }
  .el-input__inner {
    width: 100%;
  }
}
#orderlist /deep/ .el-input__inner {
  height: 34px !important;
  margin-top: 0 !important;
}
.increase_price_form {
  background: #fff;
  padding: 20px;
  .zhuijia {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .default-input {
      width: 77%;
      &/deep/.el-input__suffix {
        width: auto !important;
      }
    }
    .default-input-remark {
      width: 93%;
      height: 80px;
      &/deep/textarea {
        height: 100%;
        border-radius: 2px;
        font-size: 12px;
        resize: none;
      }
    }
  }
}
/deep/.complaint-img {
  .el-form-item__content {
    line-height: 0 !important;
  }
}
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover,
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover {
  border-color: #3455d3;
}

#orderlist.complaint /deep/ .complaint-img > span {
  display: flex;
  flex-wrap: wrap;
}

#orderlist.complaint .complaint-img /deep/ .ant-upload-list {
  width: auto !important;
}

#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card {
  margin-right: 0;
  border-radius: 2px;
}
#orderlist.remark_modal {
  &/deep/.el-dialog {
    width: 1000px !important;
  }

  &/deep/.el-dialog__body,
  &/deep/.el-dialog__footer {
    background: #eef0f3;
    margin: 0;
  }

  &/deep/.el-dialog__body {
    padding: 20px 24px !important;
  }

  &/deep/.el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;

    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
    }
  }

  .gengjiun {
    background: #fff;
    padding: 0 20px 20px;

    .modal-tit {
      height: 54px;
      padding: 20px 0 15px 0;
      font-size: 14px;
      line-height: 19px;
      color: #5e6066;
      font-weight: bold;
    }
  }
}

#orderlist /deep/.genjinupload {
  .ant-upload.ant-upload-select-picture-card {
    width: 80px !important;
    height: 80px !important;
    margin-left: 0 !important;
  }

  .ant-upload-list {
    // height: 80px !important;
  }

  .ant-upload-list-picture-card .ant-upload-list-item,
  .ant-upload-list-picture-card-container {
    width: 80px !important;
    height: 80px !important;
    padding: 0;
  }
}
</style>
<style lang="scss">
.wuliutooltip {
  background: #fff6e7 !important;
  color: #5e6066 !important;
  max-width: 232px;
  line-height: 16px;
  .popper__arrow {
    display: none !important;
  }
}
</style>